import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Attachment } from '../models/attachment';
import { catchError, map } from 'rxjs/operators';
import { Globals } from './global';
import { throwError } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { AgoraConfigService } from 'src/AgoraConfigService';
@Injectable({
  providedIn: 'root'
})
export class AttachmentService {
  httpHeaders: any;
  agoraConfigObject: any;
  constructor(private http: HttpClient, private globals: Globals, private agoraConfig: AgoraConfigService) {
    this.agoraConfigObject = this.agoraConfig.getConfig().endpoints;
    this.httpHeaders = new HttpHeaders()
      .set("Access-Control-Allow-Origin", "*").set("Access-Control-Allow-Headers", "Origin, X-Requested-With, Content-Type, Accept").set("Access-Control-Allow-Methods", "POST, GET, OPTIONS, DELETE, PUT");
  }

  attachInfo = new Attachment();

  constuctAttachmentReq(entityInfo: any, entityType: any, attachmentMode: any): Attachment {
    const attachInfo = new Attachment();
    attachInfo.meetingId = entityInfo.meetingId;
    attachInfo.fkEntityId = this.getEntityIdByType(entityInfo, entityType);
    attachInfo.attachmentEntityType = entityType;
    attachInfo.attachmentMode = attachmentMode;
    attachInfo.orgCode = this.globals.orgCode;
    attachInfo.userId = this.globals.userId;
    return attachInfo;
  }
  getEntityIdByType(entityInfo: any, entityType: any) {
    var entityId = null;
    switch (entityType) {
      case environment.noteEntityType:
        entityId = entityInfo.noteId;
        break;
      case environment.decisionEntityType:
        entityId = entityInfo.decisionId;
        break;
      case environment.taskEntityType:
        entityId = entityInfo.taskId;
        break;
      default:
        entityId = entityInfo.agendaId;
        break;
    }
    return entityId;
  }
  uploadSingleFile(file: File, entityInfo: any, entityType: any): Observable<HttpEvent<{}>> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    var attachInfo = this.constuctAttachmentReq(entityInfo, entityType, "FI");
    formData.append('attachment', JSON.stringify(attachInfo));
    return this.http.post<any>(
      `${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.attachment}` + "upload",
      formData,
      {
        headers: this.httpHeaders,
        reportProgress: true,
        observe: 'events'
      });
  }
  public saveLinkURL(reqJson: any) {
    var attachInfo = this.constuctAttachmentReq(reqJson, reqJson.entityType, "LI");
    attachInfo.attachmentLink = reqJson.attachmentLink;
    if (reqJson.attachmentId != null) {
      attachInfo.attachmentId = reqJson.attachmentId;
    }
    const formData: FormData = new FormData();
    formData.append('attachment', JSON.stringify(attachInfo));
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.attachment}` + "upload", formData, { headers: this.httpHeaders, reportProgress: true, observe: 'events' });

  }
  getAttachmentList(reqJson: any) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.attachment}` + "fetchAttachmentList", reqJson, { headers: this.httpHeaders })
      .pipe(map((data) => {
        return data;
      }), catchError(error => {
        return throwError('Something went wrong!');
      })
      )
  };

  deleteAttachment(attachmentId: any) {
    return this.http.delete<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.attachment}` + "deleteAttachment/" + attachmentId, { headers: this.httpHeaders, observe: 'response' });
  }

  getAttachmentById(attachmentId: any): Observable<HttpResponse<Blob>> {
    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.attachment}` + "getAttachmentById/" + attachmentId, { observe: 'response', responseType: 'blob' as 'json' })
  }

  getAudioAttachmentById(attachmentId: any) {
    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.attachment}getAudioAttachmentById/` + attachmentId, { observe: 'response', responseType: 'blob' as 'json' })

  }

  mergeAudio(audioDto: any) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.audio}` + "mergeAudio", audioDto, { headers: this.httpHeaders, observe: 'response' })
  }

  downloadAudio(meetingId: String) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.audio}` + "fetchAudio", meetingId, { headers: this.httpHeaders, observe: 'response' })
  }

  fetchContent(meetingId: Number) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.audio}` + "fetchContent", meetingId, { headers: this.httpHeaders, observe: 'response' })
  }

  textConvertion(res: any) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.attachment}` + "textConvertion", res, { headers: this.httpHeaders, observe: 'response' })
  }


}
